import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { SingleSelect } from "react-select-material-ui";
import {
  Grommet,
  Box,
  Header,
  Button,
  Menu,
  Main,
  Heading,
  RadioButtonGroup,
  Paragraph,
  Footer,
  Text,
  Anchor,
  DropButton,
  Stack,
  Avatar,
  TextInput,
  Grid,
  Layer,
  Card,
  Form,
  FormField,
  CheckBoxGroup,
  Select,
  CardHeader,
  CardBody,
  List,
  Image,
  CheckBox,
  DateInput,
  Tabs,
  Tab,
  Spinner,
  //IFrame,
} from "grommet";
import {
  Hpe,
  More,
  Help,
  Channel,
  Notification,
  Search,
  New,
  Like,
  Directions,
  Favorite,
  FormPrevious,
  Filter,
  Dislike,
  Chat,
  Share,
  Download,
  ScheduleNew,
  Launch,
  AddCircle,
  Edit,
  Trash,
  Validate,
  Clear,
  Play,
  Multimedia,
  DocumentPdf,
  Inspect,
  Console,
  Video,
  Close,
} from "grommet-icons";
import { hpe as theme } from "grommet-theme-hpe";
import {
  callApiGetJson,
  callApiPostJson,
  APIServerURL,
  debugLog,
  callApiText,
  logAccess,
} from "./GlobalSettings";
import auth from "./Security/Auth";
import Iframe from "react-iframe";

class StaticClickDemoFrame extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this._authChkInterval = setInterval(() => {
      console.log(
        "Interval started! for checking Auth token status and renew it from Interactive Frame"
      );
      //this.loadUpcomingEventsData();
      if (auth.verifyToken(true)) {
        console.log("Token renewed- No crying pls.");
      }
    }, 180000);
  }

  render() {
    return (
      <Layer full={true} position="center">
        {/* <Main gap="none" overflow="auto"> */}
        <Box
          align="center"
          justify="center"
          background={{ color: "white" }}
          fill="horizontal"
        >
          <Box
            align="center"
            justify="between"
            direction="row"
            gap="medium"
            fill="horizontal"
          >
            <Heading size="small" level="4" margin="small">
              {this.props.DemoTitle}
            </Heading>
            <Button icon={<Close />} secondary onClick={this.props.hide} />
          </Box>
        </Box>
        <Box align="center" justify="center" flex fill>
          <iframe
            style={{ height: "100%", width: "100%", minHeight: "100%" }}
            src={this.props.DemoUrl}
            title={this.props.DemoTitle}
          />
        </Box>
        {/* </Main> */}
      </Layer>
    );
  }
}

export default StaticClickDemoFrame;
